import { Navigate, Route, Routes } from "react-router-dom";
import { Login } from "./routes/Login";
import { Anmelden } from "./routes/Anmelden";
import { Status } from "./routes/Status";
import { Protected } from "./components/Protected";
import { Dashboard } from "./routes/app/Dashboard";
import { AnfrageDetail } from "./routes/app/AnfrageDetail";
import { NeueAnfrage } from "./routes/app/NeueAnfrage";
import { Settings } from "./routes/app/Settings";
import { MasterCompanies } from "./routes/master/Companies";
import { NewCompany } from "./routes/master/NewCompany";
import { CompanyDetail } from "./routes/master/CompanyDetail";
import { CompanyBoard } from "./routes/master/CompanyBoard";
import { WidgetsList } from "./routes/master/WidgetsList";
import { NewWidget } from "./routes/master/NewWidget";
import { WidgetDetail } from "./routes/master/WidgetDetail";
import { MasterStats } from "./routes/master/Stats";
import { AppShell } from "./components/AppShell";
import { MasterShell } from "./components/MasterShell";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      {/* Ziel des Anmelde-Links (Anmeldung ohne Passwort). */}
      <Route path="/anmelden" element={<Anmelden />} />
      {/* Auftragsverfolgung für Kunden - ohne Anmeldung, Link kommt per Mail. */}
      <Route path="/status" element={<Status />} />

      <Route
        path="/app"
        element={
          <Protected roles={["admin", "staff", "superadmin"]}>
            <AppShell />
          </Protected>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="anfragen/neu" element={<NeueAnfrage />} />
        <Route path="anfragen/:id" element={<AnfrageDetail />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route
        path="/master"
        element={
          <Protected roles={["superadmin"]}>
            <MasterShell />
          </Protected>
        }
      >
        <Route index element={<MasterCompanies />} />
        <Route path="companies/new" element={<NewCompany />} />
        <Route path="companies/:slug" element={<CompanyDetail />} />
        <Route path="companies/:slug/board" element={<CompanyBoard />} />
        <Route path="widgets" element={<WidgetsList />} />
        <Route path="widgets/new" element={<NewWidget />} />
        <Route path="widgets/:id" element={<WidgetDetail />} />
        <Route path="stats" element={<MasterStats />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
